import React, {useContext, useEffect, useState} from 'react';
import {IUser} from "../Interfaces/IUser";
import AxiosServices from "../Services/axiosServices";
import {useNavigate} from "react-router-dom";
import {setAuthToken} from "../Services/axiosConfig";

const DUser: IUser = {
    idt: -1
}

type TValue = {
    authUser: IUser,
    setAuthUser: (user: IUser) => void,
    isLoggedIn: boolean,
    setIsLoggedIn: (key: boolean) => void,
    isAdmin: boolean,
    setIsAdmin: (key: boolean) => void,
    token: string,
    setToken: (key: string) => void,
    login: (props: object) => Promise<void>,
    logout: () => void,
}

const DValue: TValue = {
    authUser: DUser,
    setAuthUser: () => {},
    isLoggedIn: false,
    setIsLoggedIn: () => {},
    isAdmin: false,
    setIsAdmin: () => {},
    token: '',
    setToken: () => {},
    login: async () => {},
    logout: () => {},
}

const AuthContext = React.createContext(DValue);

export function useAuth() {
    return useContext(AuthContext);
}

export const AuthProvider = ({children}: { children: React.ReactNode }) => {
    const [authUser, setAuthUser] = useState(DUser);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [token, setToken] = useState(() => {
        const storedToken = localStorage.getItem("token");
        return storedToken ? storedToken : '';
    });

    const navigate = useNavigate();

    const login = async (props: object) => {
        await AxiosServices.AccountLogin(props)
            .then((response) => {
                const data = response.data;
                const token = data.token;
                if (!token) {
                    alert('Connexion impossible. Veuillez réessayer.');
                    return;
                }
                setAuthToken(token);
                localStorage.setItem('token', token);
                setToken(token);
                setAuthUser(data.user);
                const user: IUser = data.user;
                setIsAdmin(user.role?.toUpperCase() === "ADMIN");
                setIsLoggedIn(true);
                navigate('/matchs');
            })
            .catch((err) => {
                const status = err?.response?.status;
                const serverMsg = err?.response?.data?.message ?? err?.response?.data ?? err?.message;
                alert(`${status ?? err?.code ?? ''} - ${serverMsg ?? 'Erreur inconnue'}`);
            });
    }

    const logout = async () => {
        setToken('');
        setIsLoggedIn(false);
        setAuthUser(DUser);
        setIsAdmin(false);
        localStorage.removeItem('token');
        navigate('/users/login');
    };

    const value: TValue = {
        authUser,
        setAuthUser,
        isLoggedIn,
        setIsLoggedIn,
        isAdmin,
        setIsAdmin,
        token,
        setToken,
        login,
        logout
    };

    // Restauration de session au démarrage
    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        if (storedToken) {
            setAuthToken(storedToken);
            setIsLoggedIn(true);
            AxiosServices.GetCurrentUser(storedToken)
                .then((user: IUser) => {
                    setAuthUser(user);
                    setIsAdmin(user?.role?.toUpperCase() === "ADMIN");
                })
                .catch(err => {
                    if (err?.response?.status === 401 || err?.response?.status === 404) {
                        logout();
                    }
                });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
